import {mapGetters, mapActions} from 'vuex';
import prettyBytes from 'pretty-bytes';
import {base} from './constants';
export default {
    data: () => ({
        fileLimit: 1,
        fileSizeLimit: 5000000,
        url:'',
        dataOptions: {
            uid: 0
        },
    }),
    computed:{
      ...mapGetters('auth', ['token']),
        uploadHeaders() {
            return {
                'authorization': `Bearer ${this.token}`
            };
        },
        action() {
            return `${base}api/${this.url}`
        },
    },
    methods:{
        ...mapActions({
            removeFile: 'removeFileAction',
        }),
        onUploadError() {
            this.$message.error(`發生錯誤，請重新匯入!`);
        },

        onExceedLimit(files) {
            this.$message.warning(`只能上傳 ${this.fileLimit}個檔案`);
        },

        beforeUpload(file) {
            if (file.size > this.fileSizeLimit) {
                this.$message.warning(`檔案超過 ${prettyBytes(this.fileSizeLimit)}`);
                return false;
            }
            return true;
        },

        async beforeRemove({response}) {
            if(response){
                await this.removeFile({key: response.key});
            }
        },

    }
}
